import {
  DUCTED_PERFORMANCE_UNAVAILABLE,
  ductedPerformanceFromCombination
} from 'utils/ducted-performance-display';
import CombinationComponentImageStrip from './combination-component-image-strip';
import DuctedCombinationCard, {
  DuctedCombinationCardProps
} from './ducted-combination-card';
import { CoverageGrid } from './overview-cards';

type DuctedFeaturedSystemCardProps = DuctedCombinationCardProps;

export default function DuctedFeaturedSystemCard(
  props: DuctedFeaturedSystemCardProps
) {
  const { combination, productData } = props;
  const performance =
    ductedPerformanceFromCombination(combination) ??
    DUCTED_PERFORMANCE_UNAVAILABLE;

  return (
    <DuctedCombinationCard
      {...props}
      testId='ducted-featured-card'
      details={
        <div className='mt-3 flex flex-col gap-2'>
          <CombinationComponentImageStrip
            combination={combination}
            productData={productData}
          />
          <CoverageGrid sides={performance} bordered />
        </div>
      }
    />
  );
}
